import Vue from "vue"
import ServiceCatalogues from "@/plugins/catalogues"

export default {
    state: () => ({
        catalogues: {},
        caching: {
            once: true,
            loaded: []
        }
    }),
    getters: {
        catalogues: (state) => {
            return state.catalogues
        }
    },
    mutations: {
        SET_CATALOGUES(state, { id, values }) {
            Vue.set(state.catalogues, id, values)
            state.caching.loaded.push(id)
        }
    },
    actions: {
        async FETCH_CATALOGUE({ commit, state }, key) {
            if (state.caching.once && state.caching.loaded.indexOf(key) > -1) {
                return
            }
            let values = (await ServiceCatalogues[key]()).data || []
            if (values.length > 0) {
                commit('SET_CATALOGUES', { id: key, values })
            }
        }
    }
}